import React from "react";
import { Route } from "react-router-dom";
import { NotificationTemplateCard } from "./NotificationTemplateCard";
import { NotificationTemplateUIProvider } from "./NotificationTemplateUIContext";

export function NotificationTemplatePage({ history }) {
  const notificationTemplateUIEvents = {
    newNotificationTemplateButtonClick: () => {
      history.push("/admin/template-notification/new");
    },
    openEditNotificationTemplatePage: id => {
      history.push(`/admin/template-notification/${id}/edit`);
    },
    openNotificationTemplateFilePage: id => {
      history.push(`/admin/template-notification/file/${id}`);
    }
  };

  return (
    <NotificationTemplateUIProvider
      notificationTemplateUIEvents={notificationTemplateUIEvents}
    >
      <NotificationTemplateCard />
    </NotificationTemplateUIProvider>
  );
}
